import React from 'react';

import { AppLogic } from '../src/components/AppLogic/AppLogic';
import { GlobalLayout } from '../src/components/Layouts/GlobalLayout';
import { SSRResult } from '../src/interfaces/nextjs';
import { Profile } from '../src/views/Profile/Profile';

export async function getServerSideProps(): SSRResult {
  return {
    props: {
      _page: 'account_overview',
      _pageTitle: 'Account Overview',
    },
  };
}

Profile.getLayout = function getLayout(page: any) {
  return (
    <AppLogic pageProps={page.props}>
      <GlobalLayout
        stickyBannerGetAppDescription="Fishbrain is better in the app"
        disableSupportChat
      >
        {page}
      </GlobalLayout>
    </AppLogic>
  );
};

export default Profile;
